import * as Yup from 'yup';

const validationSchema = Yup.object({
    token: Yup.string()
        .required('Código é obrigatório')
        .length(7, 'Código deve ter 7 caracteres'),
});

export default validationSchema;